import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { BrandNavMenu } from './BrandNavMenu';
import { BrandFooter } from './nav/BrandFooter';
import ScrollToTopButton from './ScrollToTopButton';

export class BrandLayout extends Component {
  static displayName = BrandLayout.name;

  render() {
    return (
      <div>
        <BrandNavMenu />
        <Container>
          {this.props.children}
        </Container>
        <ScrollToTopButton />
        {/*<FixedMessenger />*/}
        <BrandFooter />
      </div>
    );
  }
}
